import styled from 'styled-components'

import { helpers } from 'styles'

import { RowButton } from '../Item/RowButton'

type Props = {
	isSelected: boolean
}

export const Row = styled(RowButton)<Props>`
	background-color: ${({ theme, isSelected }) => (isSelected ? theme.color.listActive : null)};

	&:active {
		background-color: ${helpers.color.listActive};
	}
`
